import { takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import * as deliveriesApi from '../api/admin-email-deliveries.api';
import { fetchEmailDeliveries } from './admin-email-deliveries.slice';

const apiSaga = createPanelApiSaga();

/**
 * `takeLatest` BURADA YARIŞ KAPISIDIR, üslup tercihi değil.
 *
 * Süzgeç değişince yeni istek açılır; öncekinin cevabı SONRA gelebilir ve
 * `success` ile yeni listeyi ezerdi — personel "Başarısız" seçili dururken
 * gönderilmiş satırlara bakıyor olurdu. `takeLatest` önceki işçiyi İPTAL eder,
 * iptal edilen işçi `put(success)`e hiç ULAŞAMAZ.
 *
 * İki ayak da test edilir (md. 1c): bayat cevap DÜŞER **ve** güncel cevap
 * UYGULANIR — `admin-email-deliveries.saga.spec.ts`.
 */
export function* adminEmailDeliveriesSaga() {
  yield takeLatest(
    fetchEmailDeliveries.request.type,
    apiSaga(fetchEmailDeliveries, deliveriesApi.fetchEmailDeliveries),
  );
}
